import React from "react";
import {Accordion, Badge, Box, CloseButton, Flex, rem, ScrollArea, Text, Title} from "@mantine/core";
import {Person} from "lib/types";
import MatchAccordionItem from "components/matching/MatchAccordionItem";

interface Props {
    person: Person
    staticBaseUrl: string
    closeAside: () => void
}

export default function AsideContent(props: Props) {
    console.log('matches')
    console.log(props.person.fields.matches)


    return (
        <Flex direction='column' gap={rem(24)}>
            {/*Header*/}
            <Flex
                direction='row'
                bg={'#FCFCFC'}
                px={rem(24)}
                py={rem(16)}
                justify={'space-between'}
                align={'center'}
                h={rem(96)}
            >
                <Flex direction='column'>
                    <Title
                        fz={rem(20)}
                        lh={rem(32)}
                        fw={600}
                        c={'#1A1D1F'}
                    >Volunteer matches</Title>
                    <Title
                        c={'#6F767E'}
                        fw={500}
                        fz={rem(13)}
                        lh={rem(16)}
                    >for {props.person.fields.name}</Title>
                </Flex>

                <Flex
                    direction='row'
                    gap={rem(16)}
                    align={'center'}
                >
                    <Badge
                        px={rem(8)}
                        py={rem(4)}
                        c={'#fff'}
                        bg={'#249C4D'}
                        fw={700}
                        fz={rem(15)}
                        lh={rem(24)}
                        radius="md"
                        size={'xl'}
                    >
                        {props.person.fields.matches_count}
                    </Badge>
                    <CloseButton
                        onClick={() => props.closeAside()}/>
                </Flex>
            </Flex>

            {/*Matches*/}
            <ScrollArea h={'calc(100svh - 130px)'}>
                <Box px={rem(16)}>
                <Accordion
                    chevronPosition="right"
                    variant="default"
                    bg={'#FCFCFC'}
                    styles={{root: {borderRadius: 8}}}
                    className={'matches-list'}
                >
                    {props.person.fields.matches.map((match, index) => (
                        // @ts-ignore
                        <MatchAccordionItem key={index} match={match} staticBaseUrl={props.staticBaseUrl}/>
                    ))}
                </Accordion>

                <style>
                    {`
                        .matches-list .mantine-Accordion-item:last-child {
                            border-bottom: none;
                        }
                    `}
                </style>
            </Box>
            </ScrollArea>
        </Flex>
    )
}